export default __webpack_public_path__ + "static/media/fe3c3e0646f62ff2cae663612adab76b.svg";